/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2025-11-19 16:15:58
 */
import React, { useState, useEffect, useRef } from 'react'
import { Map, Marker } from 'react-amap'
import { Button, App } from 'antd'
import type { Position, LocateInfo } from './types'

interface AmapProps {
  locateInfo: LocateInfo
  handleCancel: () => void
  handleOk: (position: Position, address: string) => void
}

function Amap(props: AmapProps) {
  const { locateInfo, handleCancel, handleOk } = props
  const { message } = App.useApp()

  const [position, setPosition] = useState<Position>({
    longitude: 116.3,
    latitude: 39.9246
  })
  const [searchContent, setSearchContent] = useState('')
  const [zoom, setZoom] = useState(12)
  const geocoderRef = useRef<any>(null)

  useEffect(() => {
    let _position: Position
    const lng = Number(locateInfo.lng)
    const lat = Number(locateInfo.lat)
    if (
      locateInfo.lng &&
      locateInfo.lat &&
      lng >= -180 &&
      lng <= 180 &&
      lat >= -90 &&
      lat <= 90
    ) {
      _position = {
        longitude: lng,
        latitude: lat
      }
    } else {
      _position = {
        longitude: 116.3,
        latitude: 39.9246
      }
    }
    setSearchContent(locateInfo.address)
    setPosition(_position)
  }, [locateInfo])

  const placeSearch = (e: string) => {
    setSearchContent(e)
  }

  const mapEvents = {
    created: () => {
      let auto: any
      let geocoder: any
      // 输入提示插件
      window.AMap.plugin('AMap.Autocomplete', () => {
        auto = new window.AMap.Autocomplete({ input: 'search-input' })
      })
      // 正逆地理位置
      window.AMap.plugin(['AMap.Geocoder'], function () {
        geocoder = new window.AMap.Geocoder({
          radius: 1000,
          extensions: 'all'
        })
        geocoderRef.current = geocoder
      })

      // POI搜索插件
      window.AMap.plugin('AMap.PlaceSearch', () => {
        const place = new window.AMap.PlaceSearch({})
        // 选择地点
        window.AMap.event.addListener(auto, 'select', (e: any) => {
          place.search(e.poi.name)
          // 根据经纬度获取地理位置对象
          geocoder.getAddress(
            e.poi.location,
            function (status: string, result: any) {
              if (status === 'complete' && result.regeocode) {
                setPosition({
                  longitude: e.poi.location.lng,
                  latitude: e.poi.location.lat
                })
                setZoom(18)
                setSearchContent(e.poi.district + e.poi.address + e.poi.name)
              }
            }
          )
        })
      })

      // 首次进入定位地图
      geocoder.getLocation(searchContent, function (status: string, result: any) {
        if (status === 'complete' && result.info === 'OK') {
          setPosition({
            longitude: result.geocodes[0].location.lng,
            latitude: result.geocodes[0].location.lat
          })
          setZoom(18)
        } else {
          setZoom(18)
        }
      })
    },
    click: (e: any) => {
      if (geocoderRef.current) {
        geocoderRef.current.getAddress(
          e.lnglat,
          function (status: string, result: any) {
            if (status === 'complete' && result.regeocode) {
              setSearchContent(result.regeocode.formattedAddress)
              setPosition({ longitude: e.lnglat.lng, latitude: e.lnglat.lat })
              setZoom(18)
            }
          }
        )
      }
    }
  }

  return (
    <div className="amap-wrap">
      <div className="amap-content">
        <div className="amap-left">
          <span>
            <i>*</i>详细地址
          </span>
        </div>
        <div className="amap-right">
          <div className="amap-input">
            <input
              id="search-input"
              onChange={(e) => placeSearch(e.target.value)}
              value={searchContent}
            />
          </div>
          <div id="amap">
            <Map
              amapkey={'348f768eed5b34b13c44ebccc532b7a6'}
              plugins={['ToolBar']}
              events={mapEvents}
              center={position}
              useAMapUI={true}
              zoom={zoom}
            >
              <Marker position={position}>
                <div className="amap-marker"></div>
              </Marker>
            </Map>
          </div>
          <div className="amap-btn">
            <Button
              onClick={() => {
                handleCancel()
              }}
            >
              取消
            </Button>
            <Button
              type="primary"
              onClick={() => {
                if (searchContent.trim() === '') {
                  message.warning('地址栏不能为空！')
                  return false
                }
                handleOk(position, searchContent)
              }}
            >
              确定
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export { Amap }
export default Amap
